import React from 'react'
import styled from 'styled-components'
import { tablet } from '../../constants/breakpoints'

const Container = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 0 30px;
`
export const TextLogo = styled.div`
  cursor: pointer;
  text-decoration: none;
  color: #4c5197;

  /* Paragraph 1 - Regular */
  font-family: Inter;
  font-size: var(--Fonts-Size-Paragraph-1, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Fonts-Line-height-Paragraph-1, 30px); /* 150% */
  letter-spacing: -0.5px;

  span {
    color: #c779de;

    /* Paragraph 1 - Regular */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-1, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--Fonts-Line-height-Paragraph-1, 30px);
    letter-spacing: -0.5px;
  }
`

const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 56px;
`

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 40px;

  a {
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 25.5px;
    text-decoration: none;

    &:hover,
    &:active,
    &:focus,
    &:visited,
    &:link {
      color: #000;
      text-decoration: none;
    }
  }

  @media (max-width: calc(${tablet})) {
    display: none;
  }
`

const LoginButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 8px;

  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25.5px; /* 182.143% */
`

export const Header = () => {
  return (
    <Container>
      <LeftSide>
        <TextLogo onClick={() => window.location.replace('/')}>
          Sample<span>Bank</span>
        </TextLogo>
        <Nav>
          <a href="#">Cards</a>
          <a href="#">Business account</a>
          <a href="#">Corporate account</a>
          <a href="#">Insurance</a>
          <a href="#">About us</a>
          <a href="#">Contact</a>
        </Nav>
      </LeftSide>

      <LoginButton>
        Log in{' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.62755 7.09804C4.62755 5.66318 5.78287 4.5 7.20804 4.5H17.9195C19.3447 4.5 20.5 5.66318 20.5 7.09804V16.902C20.5 18.3368 19.3447 19.5 17.9195 19.5H7.20804C5.78287 19.5 4.62755 18.3368 4.62755 16.902V14.5735C4.62755 14.2216 4.91093 13.9363 5.2605 13.9363C5.61007 13.9363 5.89345 14.2216 5.89345 14.5735V16.902C5.89345 17.6329 6.48201 18.2255 7.20804 18.2255H17.9195C18.6455 18.2255 19.2341 17.6329 19.2341 16.902V7.09804C19.2341 6.36707 18.6455 5.77451 17.9195 5.77451H7.20804C6.48201 5.77451 5.89345 6.36707 5.89345 7.09804V9.42647C5.89345 9.77842 5.61007 10.0637 5.2605 10.0637C4.91093 10.0637 4.62755 9.77842 4.62755 9.42647V7.09804ZM10.9069 7.62778C11.1541 7.37891 11.5548 7.37891 11.802 7.62778L14.9005 10.7474C15.528 11.3791 15.528 12.4033 14.9005 13.0351L11.802 16.1547C11.5548 16.4035 11.1541 16.4035 10.9069 16.1547C10.6597 15.9058 10.6597 15.5023 10.9069 15.2534L13.5054 12.6373H5.13295C4.78338 12.6373 4.5 12.3519 4.5 12C4.5 11.6481 4.78338 11.3627 5.13295 11.3627H13.7215L10.9069 8.52899C10.6597 8.28013 10.6597 7.87664 10.9069 7.62778Z"
            fill="#A963EC"
          />
        </svg>
      </LoginButton>
    </Container>
  )
}
